import { render } from "./agent.clients.vue?vue&type=template&id=1addb30c"
import script from "./agent.clients.vue?vue&type=script&lang=js"
export * from "./agent.clients.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__